import { Box, Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import HTMLRenderer from "components/common/HTMLRenderer";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../../redux/hooks";
import Tabs from "../../../common/Tabs";
import { tabDetails } from "./TabsConfig";
import "./index.scss";

function FunctionalArea() {
  const { id } = useParams();
  const functionalAreaList: any = useAppSelector((state) => state.functionalAreas.list);
  const functionalAreaDetails = functionalAreaList.find((item: any) => item.id === id);
  const { isMobileScreen } = useContext(ThemeContext);

  return (
    <Grid container>
      <Grid
        item
        width="calc(100% + 32px)"
        md={12}
        display="flex"
        marginX={isMobileScreen ? "-15px" : "unset"}
        marginTop={isMobileScreen ? "80px" : "62px"}
        flexDirection="row"
        className="functional-area-wrapper"
        flexWrap="wrap"
        sx={{
          backgroundColor: functionalAreaDetails?.theme.bgColor
        }}
      >
        <Grid display={"flex"} flexDirection={"column"} item xs={12} md={6} gap={"16px"}>
          <div className="icon-wrapper">
            <Typography
              showBold
              color={functionalAreaDetails?.theme.textColor}
              variant="h3"
              textAlign={isMobileScreen ? "center" : "left"}
            >
              {functionalAreaDetails?.name}
            </Typography>
            <Grid>
              {isMobileScreen && (
                <Box
                  component="img"
                  alt={functionalAreaDetails?.media?.altText}
                  src={functionalAreaDetails?.media?.url}
                />
              )}
            </Grid>
          </div>
          <Typography
            component={"div"}
            color={functionalAreaDetails?.theme.textColor}
            variant="body2"
            className="content-dynamic"
          >
            <HTMLRenderer content={functionalAreaDetails?.summary} />
          </Typography>
        </Grid>
        {!isMobileScreen && (
          <Grid item md={6} display="flex" justifyContent="center">
            <Box component="img" alt={functionalAreaDetails?.media?.altText} src={functionalAreaDetails?.media?.url} />
          </Grid>
        )}
      </Grid>
      <Grid marginTop={2} item md={12}>
        <Tabs alignItems="flex-start" tabDetails={tabDetails} />
      </Grid>
    </Grid>
  );
}

export default FunctionalArea;
